import axios from "axios";
import { baseURl } from "./urls";

// Create an Axios instance with a base URL
const apiClient = axios.create({
  baseURL: baseURl, // Replace with your base URL
});

// Setup Axios interceptors
apiClient.interceptors.request.use(
  (config) => {
    // Modify the request config here (e.g., add authorization token)
    const userToken = JSON.parse(localStorage.getItem("UserData"));
    // console.log(userToken);
    // Replace with your token retrieval logic
    if (userToken) {
      config.headers[
        "Authorization"
      ] = `Bearer ${userToken?.tokens?.access?.token}`;
    }
    return config;
  },
  (error) => {
    return Promise.reject(error);
  }
);

apiClient.interceptors.response.use(
  (response) => {
    // Handle successful response here
    return response;
  },
  (error) => {
    // Handle errors here
    console.error("API call error:", error);
    return Promise.reject(error);
  }
);

export default apiClient;
